export default __webpack_public_path__ + "static/media/p2023-19.fbb4271a.jpeg";